/* 
  1、show_video_list接口test环境，没有返回cover
*/
import { showPlay } from "./audio"
import { apiClient } from "../apiClient"
import { domClientWidth, domPixelRatio, env as ENV } from "../env"
import imgUrlFilter from "../imgUrlFilter"

export const get_video_poster = async function(than, env) {

    let ifGetShow = false
    let video_field = document.createElement("div")
    video_field.className = "video_field"
    var src = than.getAttribute("src") || than.getAttribute("data-src") // 视频地址

    let cover = than.getAttribute("poster")

    var poster = cover == 'undefined' || !cover ? 'https://p6.moimg.net/md/image/default-cover.png?x-oss-process=image/resize,w_750,m_lfit/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1' : cover // 封面图

    // 视频宽度默认为屏幕宽度
    var origin_w = than.getAttribute("width") && than.getAttribute("width").length > 0 ? than.getAttribute("width").replace("px","") : ""
    // 视频高度默认为屏幕宽度的3/4
    var origin_h = than.getAttribute("height") && than.getAttribute("height").length > 0 ? than.getAttribute("height").replace("px","") : 0

    // 当屏幕高度 > 屏幕宽度时：显示比例为1:1
    // 否则，按视频原始比例渲染
    if (Number(origin_h) > 0 && Number(origin_w) > 0) {
        if (Number(origin_h) > Number(origin_w)) {
            video_field.style.paddingTop = "100%"
        } else {
            video_field.style.paddingTop = ((Number(origin_h) / Number(origin_w))).toFixed(2) * 100 + '%'
        }
    } else {
        video_field.style.paddingTop = 3 / 4 * 100 + '%'
    }
    if (poster == 'undefined' || !poster) {
        ifGetShow = true
        let obj = await getShowVideoList(src, env)
        poster = obj.poster
        src = obj.src
    }

    let is_poster = await is_img_url(poster)
    let video_cover = document.createElement("div")
    video_cover.className = "video_cover"
    video_cover.style = `background-image:url(${imgUrlFilter(is_poster, parseInt(domClientWidth() * domPixelRatio()))})`
    video_cover.innerHTML = '<i class="play_icon"></i>'

    video_field.innerHTML = `
        <video controls controlslist="${ENV.isModianIos() ? 'nofullscreen' : ''}" playsinline="true" webkit-playsinline="true">
            <source type="video/mp4">
        </video>`
    
    video_field.appendChild(video_cover)

    video_cover.addEventListener('click', async () => {
        if (!ifGetShow) {
            let obj = await getShowVideoList(src, env)
            video_field.querySelector("video").src = obj.src
        } else {
            video_field.querySelector("video").src = src
        }
        
        var father = video_field.parentNode
        while (father.className != "html-from-editor") {
            father = father.parentNode
        }
        father.querySelectorAll(".html-from-editor .audio_field").forEach(ele => {
            showPlay(ele, ele.querySelector("audio"), "video")
        })

        father.querySelectorAll(".html-from-editor .video_field").forEach(ele => {
            ele.querySelector(".video_cover").style.display = "block"
            ele.querySelector("video").pause()
        })

        video_field.querySelector(".video_cover").style.display = 'none'
        video_field.querySelector("video").play()
        
    },true)
    than.parentNode.replaceChild(video_field, than)
}

//判断图片是否存在
const is_img_url = async function (imgurl) {
    return new Promise(function (resolve) {
        var ImgObj = new Image(); //判断图片是否存在
        ImgObj.src = imgurl;
        ImgObj.onload = function () {
            resolve(imgurl);
        }
        ImgObj.onerror = function () {
            resolve('https://p6.moimg.net/md/image/default-cover.png')
        }
    })
}

const getListOne = function (list) {
    if (typeof list == 'object') {
        const arr = Object.keys(list)
        if (arr.length) return arr[0]
    }
    return 'OD'
}

const getShowVideoList = async (src, env) => {
    if (!src) return
    let poster = ""
    let new_src = ""
    let defaultValue = ''
    try {
        const res = await apiClient({
            env: env
        })({
            url: "/apis/upload/mdmedia/show_video_list",
            method: "post",
            props: {
                url: src
            },
        })
        if (res.status == 0) {
            poster = res.data.cover ? res.data.cover : ''
            defaultValue = res.data.default ? res.data.default : getListOne(res.data.list)
            new_src = res.data.list[defaultValue]
        }
        return {
            poster: poster,
            src: new_src
        }
    } catch (e) {
        return {
            poster: poster,
            src: src
        }
    }
}
